import { setMaxPages, setTotalCount, toggleCheckedItem } from '../../store/promoSlice';
import StatusBadge from '../../components/components/status_badge/StatusBadge.jsx';
import PromoActionDropdown from '../../components/components/promo_action_dropdown/PromoActionDropdown.jsx';

const ITEMS_PER_PAGE = 8;

const mockPromotions = [
    {
        id: 123,
        date: '2024-10-07',
        eventName: "Festiwal'25",
        organizer: "Festiwal'25",
        categoryId: 'music',
        organizerId: 'fest',
        eventId: 'fest25',
        promotionType: 'Basic',
        amount: 250.0,
        transaction: 'zapłacono',
        status: 'active',
    },
    {
        id: 124,
        date: '2024-10-07',
        eventName: "Festiwal'25",
        organizer: "Festiwal'25",
        categoryId: 'music',
        organizerId: 'fest',
        eventId: 'fest25',
        promotionType: 'Basic',
        amount: 250.0,
        transaction: 'zapłacono',
        status: 'finished',
    },
    {
        id: 125,
        date: '2024-10-07',
        eventName: "Festiwal'25, Konferencja NASA, Zawsze na fali w Gdansku",
        organizer: "Festiwal'25, Konferencja NASA, Zawsze na fali w Gdansku",
        categoryId: 'culture',
        organizerId: 'masters',
        eventId: 'nasa',
        promotionType: 'Premium',
        amount: 250.0,
        transaction: 'zapłacono',
        status: 'active',
    },
    {
        id: 126,
        date: '2024-10-07',
        eventName: "Festiwal'25",
        organizer: "Festiwal'25",
        categoryId: 'music',
        organizerId: 'fest',
        eventId: 'fest25',
        promotionType: 'Basic',
        amount: 250.0,
        transaction: 'zapłacono',
        status: 'active',
    },
];

const generateMockPromotions = () => {
    const base = [];
    for (let i = 0; i < 18; i += 1) {
        base.push({
            id: 200 + i,
            date: `2024-09-${String((i % 28) + 1).padStart(2, '0')}`,
            eventName: `Wydarzenie ${200 + i}`,
            organizer: `Organizator ${Math.floor(i / 2) + 1}`,
            categoryId: i % 2 === 0 ? 'music' : 'sport',
            organizerId: `org-${Math.floor(i / 2) + 1}`,
            eventId: `event-${200 + i}`,
            promotionType: i % 3 === 0 ? 'Premium' : 'Basic',
            amount: 250.0,
            transaction: 'zapłacono',
            status: i % 5 === 0 ? 'finished' : 'active',
        });
    }
    return base;
};

const allPromotions = [...mockPromotions, ...generateMockPromotions()];

const sortPromotions = (data, sortBy, sortDirection) => {
    if (!sortBy || !sortDirection) return data;
    const sorted = [...data];
    sorted.sort((a, b) => {
        const aVal = a[sortBy];
        const bVal = b[sortBy];
        if (sortBy === 'amount' || sortBy === 'id') {
            return sortDirection === 'ASC' ? aVal - bVal : bVal - aVal;
        }
        if (sortBy === 'date') {
            return sortDirection === 'ASC'
                ? new Date(aVal) - new Date(bVal)
                : new Date(bVal) - new Date(aVal);
        }
        return sortDirection === 'ASC'
            ? String(aVal).localeCompare(String(bVal))
            : String(bVal).localeCompare(String(aVal));
    });
    return sorted;
};

export const fetchPromotions = async (
    currentPage,
    sortBy,
    sortDirection,
    keyword,
    filters,
    dispatch,
    setRawPromotions
) => {
    const lowerKeyword = keyword ? keyword.toLowerCase() : '';

    let filtered = allPromotions.filter((promo) => {
        if (!lowerKeyword) return true;
        return (
            promo.eventName.toLowerCase().includes(lowerKeyword) ||
            promo.organizer.toLowerCase().includes(lowerKeyword) ||
            promo.transaction.toLowerCase().includes(lowerKeyword)
        );
    });

    if (filters) {
        if (filters.dateFrom) {
            const dateFrom = new Date(filters.dateFrom);
            filtered = filtered.filter((promo) => new Date(promo.date) >= dateFrom);
        }
        if (filters.dateTo) {
            const dateTo = new Date(filters.dateTo);
            dateTo.setHours(23, 59, 59, 999);
            filtered = filtered.filter((promo) => new Date(promo.date) <= dateTo);
        }
        if (filters.organizerId) {
            filtered = filtered.filter((promo) => promo.organizerId === filters.organizerId);
        }
        if (filters.promotionType) {
            filtered = filtered.filter((promo) => promo.promotionType === filters.promotionType);
        }
        if (filters.status) {
            filtered = filtered.filter((promo) => promo.status === filters.status);
        }
    }

    filtered = sortPromotions(filtered, sortBy, sortDirection);

    dispatch(setTotalCount(filtered.length));
    const totalPages = Math.max(1, Math.ceil(filtered.length / ITEMS_PER_PAGE));
    dispatch(setMaxPages(totalPages));

    const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
    const paginated = filtered.slice(startIndex, startIndex + ITEMS_PER_PAGE);
    setRawPromotions(paginated);
};

const formatAmount = (amount) => (
    Number(amount || 0).toFixed(2).replace('.', ',')
);

export const mapPromotionsToRows = (promotions, checkedItems, dispatch, handlers = {}) => {
    return promotions.map((promo) => {
        const isChecked = checkedItems.includes(promo.id);
        const statusLabel = promo.status === 'finished' ? 'zakończono' : 'trwa';
        const statusType = promo.status === 'finished' ? 'active' : 'pending';

        return [
            <label key={`promo-checkbox-${promo.id}`} className="checkbox-wrapper" onClick={(e) => e.stopPropagation()}>
                <input
                    type="checkbox"
                    checked={isChecked}
                    onChange={() => dispatch(toggleCheckedItem(promo.id))}
                />
            </label>,
            promo.id,
            promo.date,
            <span className="promo-event-cell" key={`promo-event-${promo.id}`}>
                {promo.eventName}
            </span>,
            <span className="promo-organizer-cell" key={`promo-org-${promo.id}`}>
                {promo.organizer}
            </span>,
            promo.promotionType,
            <span className="promo-amount-cell" key={`promo-amount-${promo.id}`}>
                {formatAmount(promo.amount)}
            </span>,
            promo.transaction,
            <div className="promo-status-cell">
                <StatusBadge status={statusType} label={statusLabel} />
            </div>,
            <div className="actions-cell promo-actions">
                <PromoActionDropdown
                    promo={promo}
                    onRenew={handlers.onRenew}
                    onPromote={handlers.onPromote}
                    onDelete={handlers.onDelete}
                />
            </div>,
        ];
    });
};
